// Libs
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';

// Actions
import { nextCheck, previousCheck } from 'REDUCERS/navSlice';

// Components
import SwipeableViews from 'react-swipeable-views';
import Box from '@material-ui/core/Box';
import Stepper from 'COMPONENTS/Stepper';
import DiagnosticCard from 'COMPONENTS/DiagnosticCard';

// Utils
import { NARROW_LAYOUT, RUNNING, SUCCESS_LEVEL, BROWSER_CHECK } from 'UTILS/constants';
import { checkList } from 'SRC/store';

const Diagnostics = () => {
  const dispatch = useDispatch();
  const currentCheck = useSelector(state => state.nav.currentCheck);
  const isSmallScreen = useSelector(state => state.app.layout === NARROW_LAYOUT);
  const currentCheckIndex = checkList.indexOf(currentCheck);
  const isCurrentCheckRunning = useSelector(state => state.checks[currentCheck]?.stage === RUNNING);
  const shouldShowBackButton = useSelector(state => state.app.backUrl || state.app.closeOnBack);
  const isBrowserCheckSuccessful = useSelector(state => state.checks[BROWSER_CHECK]?.level === SUCCESS_LEVEL);

  const handleIndexChange = (index, lastIndex) => {
    if (index > lastIndex) {
      dispatch(nextCheck());
    } else {
      dispatch(previousCheck());
    }
  };

  const containerClasses = cx('diagnostics-container', {
    'diagnostics-container_largeScreen': !isSmallScreen,
    'diagnostics-container_noBackButton': !shouldShowBackButton,
  });

  return (
    <Box className={containerClasses}>
      <Stepper />
      <SwipeableViews
        className='diagnostics-swipeWrapper'
        containerStyle={{ height: '100%' }}
        index={currentCheckIndex}
        onChangeIndex={handleIndexChange}
        disabled={isCurrentCheckRunning || !isBrowserCheckSuccessful}
        slideClassName='diagnostics-slide'
      >
        {
          checkList.map(checkLabel => (
            <DiagnosticCard key={checkLabel} checkLabel={checkLabel} />
          ))
        }
      </SwipeableViews>
    </Box>
  );
};

export default Diagnostics;
